import { DeleteFilled } from "@ant-design/icons";
import { Button, Card, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import {
    deleteTaskStatus,
    loadAllTaskStatusByProjectId,
} from "../../../redux/rtk/features/projectManagement/project/taskStatus/taskStatus";
import UpdateBtn from "../../Buttons/UpdateBtn";
import PageTitle from "../../page-header/PageHeader";
import AddTaskStatus from "./AddtaskStatus";

const TaskStatus = ({ isFixed }) => {
    const dispatch = useDispatch();
    const isLogged = Boolean(localStorage.getItem("isLogged"));
    const { loading, list=[] } = useSelector((state) => state?.taskStatus);
    const [columnsToShow, setColumnsToShow] = useState([]);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const { id } = useParams("id");
// console.log("listlist", list);

    useEffect(() => {
        dispatch(loadAllTaskStatusByProjectId(id));
    }, []);

    useEffect(() => {
        setColumnsToShow(columns);
    }, []);

    const onDelete = async (id) => {
        setDeleteLoader(true);
        const resp = await dispatch(deleteTaskStatus(id));
        if (resp.payload.message === "success") {
            setDeleteLoader(false);
            dispatch(loadAllTaskStatusByProjectId(id));
        }
    };

    if (!isLogged) {
        return <Navigate to={"/admin/auth/login"} replace={true} />;
    }

    const columns = [
        {
            id: 1,
            title: "S.No",
            dataIndex: "serial",
            key: "serial",
        },
        {
            id: 2,
            title: "Name",
            key: "name",
            render: ({ name }) => name.toUpperCase(),
        },
        {
            id: 4,
            title: "Project",
            key: "project",
            render: ({ project }) => project?.name?.toUpperCase(),
        },
        {
            id: 3,
            title: "Action",
            dataIndex: "id",
            key: "action",
            render: (id) => (
                <div className='flex justify-start'>
                    <UpdateBtn path={`/admin/task-status/update/${id}`} />
                    <Button
                        size='small'
                        style={{ width: "28px", height: "22px" }}
                        type='danger'
                        onClick={() => onDelete(id)}
                        loading={deleteLoader}
                        icon={<DeleteFilled />}
                    />
                </div>
            ),
        },
    ];

    return (
        <div>
            <PageTitle title='Back' />
            <div className="flex flex-row gap-2 mt-5">
                {/* Left Side: AddTaskStatus */}
                <div className="w-1/2">
                    <AddTaskStatus list={list} loading={loading} isFixed={isFixed} />
                </div>

                {/* Right Side: Table */}
                {isFixed && (
                    <div className="w-1/2">
                        <Card className='mb-4'>
                            <h1 className='text-xl mb-4'>
                                Task Column List :{" "}
                                <span className='font-semibold'>
                                    {list ? list[0]?.project?.name : "No Task"}
                                </span>
                            </h1>
                            <Table
                                scroll={{ x: true }}
                                loading={loading}
                                pagination={{
                                    defaultPageSize: 20,
                                }}
                                columns={columnsToShow}
                                dataSource={list}
                            />
                        </Card>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TaskStatus;